import getAudioContext from 'audio-context'

const audioContext = getAudioContext()
export default audioContext



// WEBPACK FOOTER //
// ./src/audio/audioContext.js